import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDataContext } from "../contexts/AuthContext";
import { getAvailableOrders } from '../services/api.js';
import logoAzul from "../images/logoAzul.png";
import Swal from 'sweetalert2';
import s from "../styles/Switch.module.css";

const SwitchOrder = () => {
    const navigate = useNavigate();
    const { contextData, setOrder } = useDataContext();
    const [orders, setOrders] = useState([]);
    const [selectedOrder, setSelectedOrder] = useState('');
    const [selectedOrderData, setSelectedOrderData] = useState(null);

    useEffect(() => {
        const fetchOrders = async () => {
            if (contextData.customer?.id) {
                try {
                    const orders = await getAvailableOrders(contextData.customer.id);
                    setOrders(orders);
                } catch (error) {
                    console.error('Error fetching orders:', error);
                }
            }
        };

        fetchOrders();
    }, [contextData.customer]);

    const handleOrderSelect = (order) => {
        setSelectedOrder(order.id);
        setSelectedOrderData(order);
    };

    const handleSwitchOrder = () => {
        if (!selectedOrder || !selectedOrderData) {
            Swal.fire({
                icon: 'warning',
                title: '¡Atención!',
                text: 'Elegí un pedido primero, che.',
            });
            return;
        }        
        setOrder(selectedOrder, selectedOrderData.access_code, selectedOrderData.order_type);
        
        navigate('/mcb');
    };

    const getOrderDisplayCode = (order) => {
        if (order?.access_code) return `${order.access_code}`;
        if (order?.code) return `#${order.code}`;
        return `#${order?.id ?? ""}`;
    };

    const getOrderTypeText = (order_type) => {
        switch (order_type) {
            case 2:
                return 'Extra';
            case 3:
                return 'Arreglo';
            case 4:
                return 'Faltante';
            default:
                return 'Pedido';
        }
    };

    return (
        <main className={s.page}>
            <div className={s.container}>
                <div className={s.logoWrap}>
                    <img
                        src={logoAzul}
                        alt="Little blue logo"
                        className={s.logo}
                    />
                </div>

                <h1 className={s.title}>Elegí el pedido</h1>
                <p className={s.subtitle}>Seleccioná a qué pedido querés ir</p>

                <div className={s.orderList}>
                {orders.map((order) => (
                    <div
                        key={order.id}
                        className={`${s.orderCard} ${selectedOrder === order.id ? s.orderCardSelected : ""}`}
                        onClick={() => handleOrderSelect(order)}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) =>
                            (e.key === "Enter" || e.key === " ") && handleOrderSelect(order)
                        }
                        aria-pressed={selectedOrder === order.id}
                    >
                        <div className={s.orderCardTop}>
                            <span className={s.orderCode}>{getOrderDisplayCode(order)}</span>
                            <span className={s.orderType}>Tipo: {getOrderTypeText(order.order_type)}</span>
                        </div>

                        <div className={s.orderCardBottom}>
                            <span className={s.orderHint}>
                                {selectedOrder === order.id ? 'Pedido seleccionado ✓' : 'Click para seleccionar'}
                            </span>
                            <div className={s.radio}>
                                {selectedOrder === order.id && <div className={s.radioFilled} />}
                            </div>
                        </div>
                    </div>
                ))}
                </div>

                {orders.length === 0 && (
                    <p className={s.emptyState}>No tenés pedidos disponibles.</p>
                )}

                <div className={s.footerBtns}>
                    <button
                        className={s.btnCancel}
                        onClick={() => navigate(-1)}
                    >
                        Cancelar
                    </button>
                    <button
                        className={s.btnGo}
                        disabled={!selectedOrder}
                        onClick={handleSwitchOrder}
                    >
                        Ir al pedido
                    </button>
                </div>
            </div>
        </main>
    );
};

export default SwitchOrder;
